// extracted by mini-css-extract-plugin
export default {"action":"ManageAOIs_action__t7RCZ","pageBody":"ManageAOIs_pageBody__+qLN-","aoiList":"ManageAOIs_aoiList__wO6Sj"};